import { useWindowSize as e } from "./useWindowSize.js";
const i = () => e().width < 840;
export { i as useIsMobileResize };